export default "__VITE_ASSET__C0d_6K_r__"